import { logout } from '../auth.service';
import Login from '../../pages/Login';

const HectaresSeguros = () =>
{    
    localStorage.setItem("tenantId", "hectaresseguros");
    localStorage.setItem("logoVertical", "logohectaresseguros");
    logout();
    
    return Login();
};

export default HectaresSeguros;